export const uk = {
    'accept-additions-confirm-groups':
        'Вы действительно хотите ПРИНЯТЬ все уточнения, привязанные к выбранным группам без модерации?',
    'accept-additions-single-confirm-groups':
        'Вы действительно хотите ПРИНЯТЬ все уточнения, привязанные к группе {name} без модерации?',
    'accept-moderations-confirm-groups': 'Вы действительно хотите ПРИНЯТЬ выбранные группы без модерации?',
    'accept-moderations-single-confirm-groups': 'Вы действительно хотите ПРИНЯТЬ группу {name} без модерации?',
    'actions-title': 'Действия',
    addToFavorites: 'Добавить в самые важные',
    admSendMD: 'Перемодерировать',
    'all-banners-not-saved': 'Объявления не сохранены',
    'all-banners-saved': 'Все объявления успешно сохранены',
    archive: 'Архівувати',
    'archive-success': 'Кампании добавлены в архив',
    archiveBanner: 'Архивировать',
    'banner-archive-success': 'Все выбранные баннеры добавлены в архив',
    'banner-archive-success-none': 'Не удалось добавить баннеры в архив',
    'banner-archive-success-some': {
        one: '{count} баннер из {allCount} добавлен в архив.',
        some: '{count} баннера из {allCount} добавлено в архив.',
        many: '{count} баннеров из {allCount} добавлено в архив.',
        none: '{count} баннеров из {allCount} добавлено в архив.'
    },
    'banner-delete-success': 'Все выбранные баннеры удалены',
    'banner-delete-success-none': 'Не удалось удалить баннеры',
    'banner-delete-success-some': {
        one: '{count} баннер из {allCount} удален.',
        some: '{count} баннера из {allCount} удалены.',
        many: '{count} баннеров из {allCount} удалены.',
        none: '{count} баннеров из {allCount} удалены.'
    },
    'banner-resume-success': 'Показы для баннеров возобновлены',
    'banner-resume-success-none': 'Не удалось возобновить показы баннеров',
    'banner-resume-success-some': {
        one: 'Показы для {count} баннера из {allCount} возобновлены.',
        some: 'Показы для {count} баннеров из {allCount} возобновлены.',
        many: 'Показы для {count} баннеров из {allCount} возобновлены.',
        none: 'Показы для {count} баннеров из {allCount} возобновлены.'
    },
    'banner-stop-success': 'Баннеры остановлены',
    'banner-stop-success-none': 'Не удалось остановить показы баннеров',
    'banner-stop-success-some': {
        one: '{count} баннер из {allCount} остановлен.',
        some: '{count} баннера из {allCount} остановлены.',
        many: '{count} баннеров из {allCount} остановлены.',
        none: '{count} баннеров из {allCount} остановлены.'
    },
    'banner-unarchive-success': 'Все выбранные баннеры разархивированы',
    'banner-unarchive-success-none': 'Не удалось разархивировать баннеры',
    'banner-unarchive-success-some': {
        one: '{count} баннер из {allCount} разархивирован.',
        some: '{count} баннера из {allCount} разархивированы.',
        many: '{count} баннеров из {allCount} разархивированы.',
        none: '{count} баннеров из {allCount} разархивированы.'
    },
    'banners-fail-saved': {
        one: '{count} объявление не изменено',
        some: '{count} объявления не изменены',
        many: '{count} объявлений не изменены',
        none: ''
    },
    'banners-organization-success-saved': {
        one: 'В {count} объявлении организация успешно изменена',
        some: 'В {count} объявлениях организации успешно изменены',
        many: 'В {count} объявлениях организации успешно изменены',
        none: '{count} объявлений успешно сохранены'
    },
    'banners-success-saved': {
        one: 'В {count} объявлении цены успешно изменены',
        some: 'В {count} объявлениях цены успешно изменены',
        many: 'В {count} объявлениях цены успешно изменены',
        none: '{count} объявлений успешно сохранены'
    },
    'banners-universal-with-yt-limit':
        'Выбраны только первые {count} объявлений — больше изменить за один раз нельзя. Вы можете уменьшить количество объявлений в списке, применив фильтр.',
    'campaigns-added-to-favorites': 'Кампании добавлены в самые важные',
    'campaigns-delete-success': 'Кампании удалены',
    'campaigns-removed-from-favorites': 'Кампании убраны из самых важных',
    'campaigns-universal-with-yt-limit':
        'Выбраны только первые {count} кампаний — больше изменить за один раз нельзя. Вы можете уменьшить количество кампаний в списке, применив фильтр.',
    'change-feed-filter-autobudget-priority': 'Изменить приоритет',
    'change-feed-filter-rate': 'Назначить ставку',
    copy: 'Копіювати',
    'copy-disabled-info': 'Выбранные группы не могут быть скопированы',
    'copy-disabled-info-cpm': 'Выберите только группы Медийный баннер и Видео',
    'copy-error': 'Не удалось заказать копирование',
    'copy-success': 'Для выбранных кампаний заказано копирование',
    delete: 'Видалити',
    'delete-confirm-banners': 'Вы уверены, что хотите удалить выбранные объявления?',
    'delete-confirm-campaigns': 'Вы уверены, что хотите удалить выбранные кампании?',
    'delete-confirm-feed-filters': 'Вы уверены, что хотите удалить выбранные фильтры фидов?',
    'delete-confirm-groups': 'Вы уверены, что хотите удалить выбранные группы?',
    'delete-confirm-phrases': 'Вы уверены, что хотите удалить выбранные фразы?',
    'delete-confirm-retargetings': 'Вы уверены, что хотите удалить выбранные условия ретаргетинга?',
    'delete-confirm-single-groups': 'Вы уверены, что хотите удалить группу {name}?',
    'delete-feed-filters': 'Удалить',
    'delete-phrases': 'Удалить',
    'delete-retargetings': 'Удалить',
    deleteBanners: 'Удалить',
    'disable-feed-filters': 'Выключить',
    'disable-phrases': 'Остановить',
    'edit-feed-filters': 'Редактировать',
    'edit-organization': 'Привязать организацию из справочника',
    editBanners: 'Редактировать',
    editBannersMass: 'Редактировать',
    editGroups: 'Редактировать',
    editPrices: 'Цены в объявлении',
    'enable-feed-filters': 'Включить',
    'enable-phrases': 'Включить',
    'export-to-excel': 'Экспорт в Excel',
    'export-to-excel-with-banners': 'Экспорт в Excel (с объявлениями)',
    'export-to-excel-without-banners': 'Экспорт в Excel (без объявлений)',
    'feed-filters-change-priority-error-any': 'Не удалось обновить приоритеты фильтров фидов',
    'feed-filters-change-priority-error-one': 'Не удалось обновить приоритет фильтра фида',
    'feed-filters-change-priority-success-any': 'Успешно обновлены приоритеты всех выбранных фильтров фидов',
    'feed-filters-change-priority-success-one': 'Успешно обновлен приоритет фильтра фида',
    'feed-filters-change-priority-warning': {
        one: 'Успешно обновлен приоритет {count} фильтра фида из {totalCount}',
        some: 'Успешно обновлены приоритеты {count} фильтров фидов из {totalCount}',
        many: 'Успешно обновлены приоритеты {count} фильтров фидов из {totalCount}',
        none: 'Успешно обновлены приоритеты {count} фильтров фидов из {totalCount}'
    },
    'feed-filters-change-rate-error-any': 'Не удалось обновить ставки фильтров фидов',
    'feed-filters-change-rate-error-one': 'Не удалось обновить ставку фильтра фида',
    'feed-filters-change-rate-success-any': 'Успешно обновлены ставки всех выбранных фильтров фидов',
    'feed-filters-change-rate-success-one': 'Успешно обновлена ставка фильтра фида',
    'feed-filters-change-rate-warning': {
        one: 'Успешно обновлена ставка {count} фильтра фида из {totalCount}',
        some: 'Успешно обновлены ставки {count} фильтров фидов из {totalCount}',
        many: 'Успешно обновлены ставки {count} фильтров фидов из {totalCount}',
        none: 'Успешно обновлены ставки {count} фильтров фидов из {totalCount}'
    },
    'feed-filters-delete-error-any': 'Не удалось удалить фильтры фидов',
    'feed-filters-delete-error-one': 'Не удалось удалить фильтр фида',
    'feed-filters-delete-success-any': 'Успешно удалены все выбранные фильтры фидов',
    'feed-filters-delete-success-one': 'Успешно удален фильтр фида',
    'feed-filters-delete-warning': {
        one: 'Успешно удален {count} фильтр фида из {totalCount}',
        some: 'Успешно удалены {count} фильтра фида из {totalCount}',
        many: 'Успешно удалены {count} фильтров фидов из {totalCount}',
        none: 'Успешно удалены {count} фильтров фидов из {totalCount}'
    },
    'feed-filters-disable-error-any': 'Не удалось выключить фильтры фидов',
    'feed-filters-disable-error-one': 'Не удалось выключить фильтр фида',
    'feed-filters-disable-success-any': 'Успешно выключены все выбранные фильтры фидов',
    'feed-filters-disable-success-one': 'Успешно выключен фильтр фида',
    'feed-filters-disable-warning': {
        one: 'Успешно выключен {count} фильтр фида из {totalCount}',
        some: 'Успешно выключены {count} фильтры фидов из {totalCount}',
        many: 'Успешно выключены {count} фильтры фидов из {totalCount}',
        none: 'Успешно выключены {count} фильтры фидов из {totalCount}'
    },
    'feed-filters-enable-error-any': 'Не удалось включить фильтры фидов',
    'feed-filters-enable-error-one': 'Не удалось включить фильтр фида',
    'feed-filters-enable-success-any': 'Успешно включены все выбранные фильтры фидов',
    'feed-filters-enable-success-one': 'Успешно включен фильтр фида',
    'feed-filters-enable-warning': {
        one: 'Успешно включен {count} фильтр фида из {totalCount}',
        some: 'Успешно включены {count} фильтры фидов из {totalCount}',
        many: 'Успешно включены {count} фильтры фидов из {totalCount}',
        none: 'Успешно включены {count} фильтры фидов из {totalCount}'
    },
    'feed-filters-universal-with-yt-limit':
        'Выбраны только первые {count} фильтров — больше изменить за один раз нельзя. Вы можете уменьшить количество фильтров в списке, применив фильтрацию.',
    goToBanners: 'Объявления',
    goToGroups: 'Группы',
    goToLogs: 'История изменений',
    goToMol: 'Перейти в Мастер отчётов',
    goToPhrases: 'Фразы',
    goToTargeting: 'Условия показа',
    'group-adm-send-md-error': 'Не удалось отправить группы на перемодерацию',
    'group-adm-send-md-success': 'Группы отправлены на перемодерацию',
    'group-archive-success': 'Все выбранные группы добавлены в архив',
    'group-archive-success-none': 'Не удалось добавить группы в архив',
    'group-archive-success-some': {
        one: '{count} группа из {allCount} добавлена в архив.',
        some: '{count} группы из {allCount} добавлены в архив.',
        many: '{count} групп из {allCount} добавлены в архив.',
        none: '{count} групп из {allCount} добавлены в архив.'
    },
    'group-can-not-be-accept-moderation-additions': 'Нет подходящих групп для операции',
    'group-can-not-be-adm-send-md': 'Нет подходящих групп для операции',
    'group-can-not-be-moderate-accept': 'Нет подходящих групп для операции',
    'group-can-not-be-remoderate-additions': 'Нет подходящих групп для операции',
    'group-can-not-be-send-moderate': 'Нет подходящих групп для операции',
    'group-can-not-regions-transform': 'Нет подходящих групп для операции',
    'group-can-not-sendBK': 'Нет подходящих групп для операции',
    'group-delete-success': 'Группы удалены',
    'group-delete-success-none': 'Не удалось удалить группы',
    'group-delete-success-some': {
        one: '{count} группа из {allCount} удалена',
        some: '{count} группы из {allCount} удалены',
        many: '{count} групп из {allCount} удалено',
        none: '{count} групп из {allCount} удалено'
    },
    'group-exceeded-max-size': 'Количество выбранных групп должно быть меньше 1000',
    'group-exceeded-max-size-to-accept-moderation-additions': 'Количество выбранных групп должно быть меньше 1000',
    'group-exceeded-max-size-to-adm-send-md': 'Количество выбранных групп должно быть меньше 1000',
    'group-exceeded-max-size-to-copy': 'Количество выбранных групп должно быть меньше 1000',
    'group-exceeded-max-size-to-delete': 'Количество выбранных групп должно быть меньше 1000',
    'group-exceeded-max-size-to-moderate-accept': 'Количество выбранных групп должно быть меньше 1000',
    'group-exceeded-max-size-to-regions-transform': 'Количество выбранных групп должно быть меньше 1000',
    'group-exceeded-max-size-to-remoderate-additions': 'Количество выбранных групп должно быть меньше 1000',
    'group-exceeded-max-size-to-send-moderate': 'Количество выбранных групп должно быть меньше 1000',
    'group-exceeded-max-size-to-sendBK': 'Количество выбранных групп должно быть меньше 1000',
    'group-moderate-accept-banners-additions-error': 'Не удалось отправить группы на подтверждение модерации уточнений',
    'group-moderate-accept-banners-additions-success': 'Группы отправлены на подтверждение модерации уточнений',
    'group-moderate-accept-banners-additions-success-some': {
        one: '{count} группа из {allCount} отправлена на подтверждение модерации уточнений',
        some: '{count} группы из {allCount} отправлены на подтверждение модерации уточнений',
        many: '{count} групп из {allCount} отправлены на подтверждение модерации уточнений',
        none: '{count} групп из {allCount} отправлены на подтверждение модерации уточнений'
    },
    'group-moderate-accept-error': 'Не удалось отправить группы на подтверждение модерации',
    'group-moderate-accept-success': 'Группы отправлены на подтверждение модерации',
    'group-remoderate-banners-additions-error': 'Не удалось отправить группы на перемодерацию уточнений',
    'group-remoderate-banners-additions-success': 'Группы отправлены на перемодерацию уточнений',
    'group-remoderate-banners-additions-success-some': {
        one: '{count} группа из {allCount} отправлена на перемодерацию уточнений',
        some: '{count} группы из {allCount} отправлены на перемодерацию уточнений',
        many: '{count} групп из {allCount} отправлены на перемодерацию уточнений',
        none: '{count} групп из {allCount} отправлены на перемодерацию уточнений'
    },
    'group-resume-success': 'Показы для всех выбранных групп возобновлены',
    'group-resume-success-none': 'Не удалось возобновить показы групп',
    'group-resume-success-some': {
        one: 'Показы для {count} группы из {allCount} возобновлены.',
        some: 'Показы для {count} групп из {allCount} возобновлены.',
        many: 'Показы для {count} групп из {allCount} возобновлены.',
        none: 'Показы для {count} групп из {allCount} возобновлены.'
    },
    'group-send-moderate-error': 'Не удалось отправить группы на модерацию',
    'group-send-moderate-success': 'Группы отправлены на модерацию',
    'group-send-moderate-success-some': {
        one: '{count} группа из {allCount} отправлена на модерацию',
        some: '{count} группы из {allCount} отправлены на модерацию',
        many: '{count} групп из {allCount} отправлены на модерацию',
        none: '{count} групп из {allCount} отправлены на модерацию'
    },
    'group-sendBK-error': 'Не удалось отправить группы в БК',
    'group-sendBK-success': 'Группы отправлены в БК',
    'group-single-adm-send-md-error': 'Не удалось отправить группу {name} на перемодерацию',
    'group-single-adm-send-md-success': 'Группа {name} отправлена на перемодерацию',
    'group-single-delete-error': 'Не удалось удалить группу {name}',
    'group-single-delete-success': 'Группа {name} удалена',
    'group-single-moderate-accept-banners-additions-error':
        'Не удалось отправить группу {name} на подтверждение модерации уточнений',
    'group-single-moderate-accept-banners-additions-success':
        'Группа {name} отправлена на подтверждение модерации уточнений',
    'group-single-moderate-accept-error': 'Не удалось отправить группу {name} на подтверждение модерации',
    'group-single-moderate-accept-success': 'Группа {name} отправлена на подтверждение модерации',
    'group-single-remoderate-banners-additions-error': 'Не удалось отправить группу {name} на перемодерацию уточнений',
    'group-single-remoderate-banners-additions-success': 'Группа {name} отправлена на перемодерацию уточнений',
    'group-single-send-moderate-error': 'Не удалось отправить группу {name} на модерацию',
    'group-single-send-moderate-success': 'Группа {name} отправлена на модерацию',
    'group-single-sendBK-error': 'Не удалось отправить группу {name} в БК',
    'group-single-sendBK-success': 'Группа {name} отправлена в БК',
    'group-stop-success': 'Все выбранные группы остановлены',
    'group-stop-success-none': 'Не удалось остановить показы групп',
    'group-stop-success-some': {
        one: '{count} группа из {allCount} остановлены.',
        some: '{count} группы из {allCount} остановлены.',
        many: '{count} групп из {allCount} остановлено.',
        none: '{count} групп из {allCount} остановлено.'
    },
    'group-unarchive-success': 'Все выбранные группы разархивированы',
    'group-unarchive-success-none': 'Не удалось разархивировать группы',
    'group-unarchive-success-some': {
        one: '{count} группа из {allCount} разархивирована.',
        some: '{count} группы из {allCount} разархивированы.',
        many: '{count} групп из {allCount} разархивировано.',
        none: '{count} групп из {allCount} разархивировано.'
    },
    'groups-universal-with-yt-limit':
        'Выбраны только первые {count} групп — больше изменить за один раз нельзя. Вы можете уменьшить количество групп в списке, применив фильтр.',
    'internal-tool-title': 'Внутренние инструменты',
    moderate: 'Отправить на модерацию',
    moderateAccept: 'Подтвердить модерацию',
    moderateAcceptBannersAdditions: 'Модерация: принять уточнения',
    'no-editable': 'Редактирование недоступно',
    'one-banners-not-saved': 'Объявление не сохранено',
    'one-banners-saved': 'Объявление успешно сохранено',
    'open-search-and-replace-inspector': 'Найти и заменить',
    openMinusPhraseSelector: 'Настроить наборы минус-фраз',
    openMinusPhraseSelectorDisabledInfo:
        'Выберите только группы кампаний "Текстово-графические объявления" и "Баннер на поиске"',
    openMinusPhraseSelectorNoRights: 'Нет прав для настройки наборов минус-фраз',
    openMinusPhraseSelectorOverMaxInfo: 'Количество выбранных групп должно быть меньше {count}',
    openPhrasesSelectorWizard: 'Подобрать фразы',
    payByCash: 'Пополнить наличными',
    'phrases-delete-success': 'Фразы удалены',
    'phrases-disable-success': 'Фразы остановлены',
    'phrases-enable-success': 'Фразы включены',
    'phrases-set-common-price-error-all': 'Не удалось установить ставку',
    'phrases-set-common-price-error-one': 'Не удалось установить ставку',
    'phrases-set-common-price-success-all': 'Ставка установлена',
    'phrases-set-common-price-success-one': 'Ставка установлена',
    'phrases-set-common-price-warning': {
        one: 'Ставка установлена для {count} фразы из {totalCount}',
        some: 'Ставка установлена для {count} фраз из {totalCount}',
        many: 'Ставка установлена для {count} фраз из {totalCount}',
        none: 'Ставка установлена для {count} фраз из {totalCount}'
    },
    'phrases-universal-with-yt-limit':
        'Выбраны только первые {count} фраз — больше изменить за один раз нельзя. Вы можете уменьшить количество фраз в списке, применив фильтр.',
    'phrases-wizard-data-set-none': 'Ставки не были применены ни к одной фразе',
    'phrases-wizard-data-set-success':
        'Новые ставки успешно установлены для {setCount} фраз из {phrasesCount}. Активация займёт около 30 минут.',
    'phrases-wizard-data-set-success-with-yt-limit':
        'Новые ставки успешно установлены для {setCount} фраз. Активация займёт около 30 минут. Остальные фразы не попали в выборку из-за технического ограничения. Отфильтруйте эти фразы и повторите назначение ставок.',
    pricesWizard: 'Мастер ставок',
    'regions-transform': 'Настроить регионы показа',
    'regions-transform-access-error': 'Нет прав для настройки регионов показа',
    remoderate: 'Перемодерувати',
    'remoderate-success': 'Кампании отправлены на перемодерацию',
    remoderateBannersAdditions: 'Перемодерация уточнений',
    removeFromFavorites: 'Убрать из самых важных',
    resume: 'Відновити покази',
    'resume-retargetings': 'Активировать',
    'resume-success': 'Показы для кампаний возобновлены',
    resumeBanner: 'Возобновить показы',
    'retargetings-delete-error-all': 'Не удалось удалить условия',
    'retargetings-delete-error-one': 'Не удалось удалить условие',
    'retargetings-delete-success-all': 'Все выбранные условия удалены',
    'retargetings-delete-success-one': 'Условие удалено',
    'retargetings-delete-warning-some': {
        one: '{count} условие из {totalCount} удалено',
        some: '{count} условия из {totalCount} удалены',
        many: '{count} условий из {totalCount} удалено',
        none: '{count} условий из {totalCount} удалено'
    },
    'retargetings-resume-error-all': 'Не удалось возобновить условия',
    'retargetings-resume-error-one': 'Не удалось возобновить условие',
    'retargetings-resume-success-all': 'Все выбранные условия возобновлены',
    'retargetings-resume-success-one': 'Условие возобновлено',
    'retargetings-resume-warning-some': {
        one: '{count} условие из {totalCount} возобновлено',
        some: '{count} условия из {totalCount} возобновлены',
        many: '{count} условий из {totalCount} возобновлено',
        none: '{count} условий из {totalCount} возобновлено'
    },
    'retargetings-set-common-price-error-all': 'Не удалось установить ставку',
    'retargetings-set-common-price-error-one': 'Не удалось установить ставку',
    'retargetings-set-common-price-success-all': 'Ставка установлена',
    'retargetings-set-common-price-success-one': 'Ставка установлена',
    'retargetings-set-common-price-warning-some': {
        one: 'Ставка установлена для {count} условия из {totalCount}',
        some: 'Ставка установлена для {count} условий из {totalCount}',
        many: 'Ставка установлена для {count} условий из {totalCount}',
        none: 'Ставка установлена для {count} условий из {totalCount}'
    },
    'retargetings-suspend-error-all': 'Не удалось остановить условия',
    'retargetings-suspend-error-one': 'Не удалось остановить условие',
    'retargetings-suspend-success-all': 'Все выбранные условия остановлены',
    'retargetings-suspend-success-one': 'Условие остановлено',
    'retargetings-suspend-warning-some': {
        one: '{count} условие из {totalCount} остановлено',
        some: '{count} условия из {totalCount} остановлены',
        many: '{count} условий из {totalCount} остановлено',
        none: '{count} условий из {totalCount} остановлено'
    },
    'retargetings-universal-with-yt-limit':
        'Выбраны только первые {count} правил показа — больше изменить за один раз нельзя. Вы можете уменьшить количество правил показа в списке, применив фильтр.',
    sendBK: 'Отправить в БК',
    'sendBK-confirm-groups': 'Вы уверены, что хотите отправить выбранные группы в БК?',
    'sendBK-confirm-single-groups': 'Вы уверены, что хотите отправить группу {name} в БК?',
    sendModerate: 'Отправить на модерацию',
    sendModerateByClient: 'Отправить на модерацию',
    'set-common-price': 'Установить единую ставку',
    'status-title': 'Статус',
    stop: 'Зупинити',
    'stop-success': 'Кампании остановлены',
    stopBanner: 'Остановить',
    'suspend-retargetings': 'Остановить',
    'tool-title': 'Инструменты',
    unarchive: 'Розархівувати',
    'unarchive-success': 'Кампании разархивированы',
    unarchiveBanner: 'Разархивировать',
    'unknown-error': 'Неизвестная ошибка',
    'users-profile-universal-with-yt-limit':
        'Выбраны только первые {count} правил показа — больше изменить за один раз нельзя. Вы можете уменьшить количество правил показа в списке, применив фильтр.'
};
